$(document).ready(function(e) {
	
	$(".btn_scorall").click(function() {
		$('html, body').animate({
			scrollTop: $("#getOrder").offset().top - 50
		}, 2000);
	});
	
	$('.avail_cat').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		fade: false,
		autoplay: false,
		autoplaySpeed: 11000,
		dots: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {slidesToShow: 3}
			},
			
			{
				breakpoint: 767,
				settings:{slidesToShow: 1}
				
			}
		]
	});	
			
	//accordion JS 
	$(".acdn-heading").click(function() {
			
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
			if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
		});
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
		
	});
	
	var numSlick = 0;
	$('.package-slide-div').each( function() {
	  numSlick++;
	  $(this).addClass( 'slider-' + numSlick ).slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		asNavFor: '.package-slider-nav.slider-' + numSlick
	  });
	});
	
	numSlick = 0;
	$('.package-slider-nav').each( function() {
	  numSlick++;
	  $(this).addClass( 'slider-' + numSlick ).slick({
		vertical: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		asNavFor: '.package-slide-div.slider-' + numSlick,
		arrow: true,
		focusOnSelect: true,
	  });
	});	
	
	
	/*====POPUP_JS_START====*/

    // Check if user has verified age OR if URL has &pop=0
    const urlParams = new URLSearchParams(window.location.search);
    const popParam = urlParams.get('pop');
    const ageVerified = sessionStorage.getItem('ageVerified');

    if (ageVerified || popParam === '0') {
        $('.popup-Box').hide();

        // If ageVerified was used, clear it after 10 seconds
        if (ageVerified) {
            setTimeout(() => {
                sessionStorage.removeItem('ageVerified');
            }, 900000); // 10,000 ms = 10 seconds
        }
    }






	
	$('.preferlink').click(function(e) {
    // Quiz Navigation
    $('.next_btn input[type="radio"]').on('change', function () {
        let $currentBox = $(this).closest('.question_Box');
        let $nextBox = $currentBox.next('.question_Box');
        $currentBox.hide();
        $nextBox.show();
    });

      // Prefer click handler — final step
      $('.preferlink input[type="radio"][name="prefer"]').on('change', function () {
        let condiVal = $('input[name="condi"]:checked').val();
        let preferVal = $('input[name="prefer"]:checked').val();
        let baseUrl = window.location.href.split('?')[0];
        
        // Create new URLSearchParams object from current URL
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search);

        // Set or update necessary params
        params.set('pop', '0');
        params.set('prefer', preferVal);

        let redirectMap = {
          be: '/pages/lp14',
          md: '/pages/lp15',
          ex: 'current'
        };

        let redirectUrl = redirectMap[condiVal] || 'current';

        if (redirectUrl !== 'current') {
          // Redirect to another page with updated params
          window.location.href = `${redirectUrl}?${params.toString()}`;
          return;
        } else {
          // Redirect to the same page with clean params
          window.history.pushState({}, '', `/pages/lp16?${params.toString()}`);
        }

            // Updated Preselect Logic (duplicates allowed)
            const preferOptions = {
                chill: ['slurricane', 'rainbow', 'purple', 'sub', 'dark'],
                good: ['tangie', 'jealousy'],
                focus: ['genius', 'eureka', 'pluto', 'gary']
            };

            let keywords = preferOptions[preferVal] || [];

            let group1Prices = []; // strain-1 to strain-3
            let group2Prices = []; // strain-4 and strain-7
            let group3Prices = []; // strain-8 and strain-12

            $('select[id^="strain-"]').each(function () {
                const $select = $(this);
                const id = $select.attr('id');
                const matchingOptions = [];

                // Match based on visible options and keywords
                $select.find('option').each(function () {
                    const $option = $(this);
                    const text = $option.text().toLowerCase().trim();
                    const isVisible = $option.css('display') !== 'none';

                    const matchedKeyword = keywords.find(keyword => text.includes(keyword));
                    if (isVisible && matchedKeyword) {
                        matchingOptions.push({ element: $option });
                    }
                });

                // Preselect a random matching option
                if (matchingOptions.length > 0) {
                    const { element } = matchingOptions[Math.floor(Math.random() * matchingOptions.length)];
                    $select.val(element.val());
                } else {
                    $select.val(''); // fallback to default
                }

                $select.trigger('change');

                // Get selected option and its data-vprice
                const selectedOption = $select.find('option:selected');
                const vprice = selectedOption.data('vprice');

                // Assign vprice to appropriate group
                if (['strain-1', 'strain-2', 'strain-3'].includes(id)) {
                    group1Prices.push(Number(vprice) || 0);
                } else if (['strain-4', 'strain-5', 'strain-6', 'strain-7'].includes(id)) {
                    group2Prices.push(Number(vprice) || 0);
                }else if (['strain-8', 'strain-9', 'strain-10', 'strain-11', 'strain-12'].includes(id)) {
                    group3Prices.push(Number(vprice) || 0);
                }
            });

            // At this point, you can use group1Prices and group2Prices however you need
            console.log('Group 1 Prices:', group1Prices); // strain-1 to strain-3
            console.log('Group 2 Prices:', group2Prices); // strain-4 and strain-5
            console.log('Group 3 Prices:', group3Prices); // strain-4 and strain-5
            const sumGroup1 = group1Prices.reduce((a, b) => a + b, 0);
            const sumGroup2 = group2Prices.reduce((a, b) => a + b, 0);
            const sumGroup3 = group3Prices.reduce((a, b) => a + b, 0);
            console.log('Group 1 TotalPrices:', sumGroup1); // strain-1 to strain-3
            console.log('Group 2 TotalPrices:', sumGroup2); // strain-4 and strain-7
            console.log('Group 3 TotalPrices:', sumGroup3); // strain-8 and strain-12


            // Hide popup if exists
            $('.popup-Box').hide();
        });
	});
	
	$('.next_btn').click(function(e) {		
		var item = $(this);	
		setTimeout(function(){
			$(item).closest('.question_Box').hide();
			$(item).closest('.question_Box').next('.question_Box').show();
		progress();
		}, 300);
		$('body,html').animate({scrollTop: 0}, 100);
	});
	
	
	/*====POPUP_JS_END====*/		

  function updateTotalsFromSelection() {
      let group1Prices = [];
      let group2Prices = [];
      let group3Prices = [];

      $('select[id^="strain-"]').each(function () {
          const $select = $(this);
          const id = $select.attr('id');
          const selectedOption = $select.find('option:selected');
          const vprice = Number(selectedOption.data('vprice')) || 0;

          if (['strain-1', 'strain-2', 'strain-3'].includes(id)) {
              group1Prices.push(vprice);
          } else if (['strain-4', 'strain-5', 'strain-6', 'strain-7'].includes(id)) {
              group2Prices.push(vprice);
          } else if (['strain-8', 'strain-9', 'strain-10', 'strain-11', 'strain-12'].includes(id)) {
              group3Prices.push(vprice);
          }
      });

      const sumGroup1 = group1Prices.reduce((a, b) => a + b, 0);
      const sumGroup2 = group2Prices.reduce((a, b) => a + b, 0);
      const sumGroup3 = group3Prices.reduce((a, b) => a + b, 0);
    const sumDpriceA = (sumGroup1 - (sumGroup1 * 0.10)).toFixed(2);
    const sumDpriceB = (sumGroup2 - (sumGroup2 * 0.15)).toFixed(2);
    const sumDpriceC = (sumGroup3 - (sumGroup3 * 0.20)).toFixed(2);

      console.log('Updated Group 1 TotalPrices:', sumGroup1);
      console.log('Updated Group 2 TotalPrices:', sumGroup2);
      console.log('Updated Group 3 TotalPrices:', sumGroup3);

      // Optional: update values in the DOM if needed
      $('#vPriceA').text(`$${sumGroup1}`);
      $('#vPriceB').text(`$${sumGroup2}`);
      $('#vPriceC').text(`$${sumGroup3}`);
      $('#dPriceA').text(`$${sumDpriceA}`);
      $('#dPriceB').text(`$${sumDpriceB}`);
      $('#dPriceC').text(`$${sumDpriceC}`);
  }

  // Attach separate onchange listener
  $('select[id^="strain-"]').on('change', updateTotalsFromSelection);


  function toggleAllSelectOptions(toggleId) {
    const checkbox = document.getElementById(toggleId);
    const showGroup = checkbox.checked ? '7' : '3.5';

    const selects = document.querySelectorAll('select[data-toggle-group="true"]');

    selects.forEach(select => {
      const currentOption = select.options[select.selectedIndex];
      const currentLabel = currentOption ? currentOption.text : "";
      const productNameMatch = currentLabel.match(/^(.+?)\s*-\s*/);
      const currentProductName = productNameMatch ? productNameMatch[1].trim() : null;

      let matchedNewOption = null;

      for (const option of select.options) {
        if (option.value === "") {
          option.style.display = "block"; // keep "Select Option"
          continue;
        }

        const isMatch = option.dataset.group === showGroup;
        option.style.display = isMatch ? "block" : "none";

        if (isMatch && currentProductName && option.text.startsWith(currentProductName + " -")) {
          matchedNewOption = option;
        }
      }

      if (matchedNewOption) {
        select.value = matchedNewOption.value;
      } else {
        select.selectedIndex = 0;
      }
    });

    // ✅ Recalculate totals after changes
    updateTotalsFromSelection();
  }

  const toggleCheckbox = document.getElementById('toggle-group');
  if (toggleCheckbox) {
    toggleCheckbox.addEventListener('change', function () {
      toggleAllSelectOptions('toggle-group');
    });
  }




function autoSelectByPreferParam() {
	const urlParams = new URLSearchParams(window.location.search);
	const preferVal = urlParams.get('prefer');

	const preferOptions = {
		chill: ['slurricane', 'rainbow', 'purple', 'sub', 'dark'],
		good: ['tangie', 'jealousy'],
		focus: ['genius', 'eureka', 'pluto', 'gary']
	};

	if (!preferVal || !(preferVal in preferOptions)) return;

	const keywords = preferOptions[preferVal] || [];

	let group1Prices = [];
	let group2Prices = [];

	$('select[id^="strain-"]').each(function () {
		const $select = $(this);
		const id = $select.attr('id');
		const matchingOptions = [];

		$select.find('option').each(function () {
			const $option = $(this);
			const text = $option.text().toLowerCase().trim();
			const isVisible = $option.css('display') !== 'none';

			const matchedKeyword = keywords.find(keyword => text.includes(keyword));
			if (isVisible && matchedKeyword) {
				matchingOptions.push({ element: $option });
			}
		});

		if (matchingOptions.length > 0) {
			const { element } = matchingOptions[Math.floor(Math.random() * matchingOptions.length)];
			$select.val(element.val());

			// Use native change event
			$select[0].dispatchEvent(new Event('change', { bubbles: true }));
		} else {
			$select.val('');
		}

		const selectedOption = $select.find('option:selected');
		const vprice = selectedOption.data('vprice');

		if (['strain-1', 'strain-2', 'strain-3'].includes(id)) {
			group1Prices.push(Number(vprice) || 0);
		} else if (['strain-4', 'strain-5'].includes(id)) {
			group2Prices.push(Number(vprice) || 0);
		}
	});

	const sumGroup1 = group1Prices.reduce((a, b) => a + b, 0);
	const sumGroup2 = group2Prices.reduce((a, b) => a + b, 0);

	console.log('Group 1 Prices:', group1Prices);
	console.log('Group 2 Prices:', group2Prices);
	console.log('Group 1 TotalPrices:', sumGroup1);
	console.log('Group 2 TotalPrices:', sumGroup2);
}

// Ensure DOM and external scripts have loaded
window.addEventListener('load', autoSelectByPreferParam);









	
});

function progress(){
	var progressVal = $('.question_Box:visible').attr('data-wdth');
	setTimeout(function () {		
		if (progressVal >= 100 ){
			$('ul.progress_list li.s3').addClass('active');
		} else if (progressVal > 50){
			$('ul.progress_list li.s2').addClass('active');
		} else if (progressVal > 0){
			$('ul.progress_list li.s2').addClass('active');	
		}else {
			$('ul.progress_list li.s1').addClass('active');
		}
	}, 100);
}



function isScrolledIntoView(elem) {
	var docViewTop = $(window).scrollTop();
	var docViewBottom = docViewTop + $(window).height();
	
	var elemTop = $(elem).offset().top;
	var elemBottom = elemTop + $(elem).height();
	
	return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop));
}

$(document).scroll(function() {
		
	if ($(this).scrollTop() > 40){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
	
	var $elem = $('.fixed_btn');
	var $window = $(window);

	var docViewTop = $window.scrollTop();
	var docViewBottom = docViewTop + $window.height();

	var elemTop = $elem.offset().top;
	var elemBottom = elemTop + $elem.height();

	if (elemTop >= (docViewBottom + 20) || (elemTop + $('#call-btn').height()) >= (docViewBottom + 104)) {
			
		if (isScrolledIntoView('.section7') === true) {
			$('#call-btn').css('position', 'relative');
			
		} else {
			$('#call-btn').css('position', 'fixed');
		}
	} else {
		$('#call-btn').css({'position' : 'relative'});
	}
	
});